import { gql } from '@apollo/client';

export const GET_TESTERS_EXPIRED = gql`
  query TestSessionsExpired(
    $projectId: ID!,
  ) {
    testSessionsExpired(
      projectId: $projectId,
    ) {
      id
      status
      expiresAt
      videoUrl
       tester {
        id
        user {
          tester
          id
          email
          profile {
            id
            firstName
            lastName
          }
        }
      }
    
    }
  }
`;
